export const HeliosInterruptNotificationStates = {
    ACCEPTED: 'Accepted',
    ASSIGNED: 'Assigned',
    SNOOZED: 'Snoozed',
}

export const HeliosInterruptNotificationConstants = {
    NOTIFICATION_TYPES: Object.freeze(['HELIOS']),
    PROCESS_NAME: 'HeliosLaborMove',
    TIMEOUT_MS: 30000, // Set to 30s for P0 and internal testing, will modify based on user feedback with backend team
}
